import { Component, OnInit } from '@angular/core';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-contact-info-section',
  templateUrl: './contact-info-section.component.html',
  styleUrls: ['./contact-info-section.component.css']
})
export class ContactInfoSectionComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  jumpto(anchor) {
    const top = document.getElementById(anchor).offsetTop;
    window.scrollTo(0, top);
  }
}



// WEBPACK FOOTER //
// ./src/app/contact-info-section/contact-info-section.component.ts